import React, { Component } from "react";
import {
  Grid,
  Paper,
  Typography,
  Divider,
  withStyles,
  Button,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import clsx from "clsx";
import SimpleModal from "../../components/data/image_modal";

const styles = {
  root: {
    flexGrow: 1,
    width: "100%",
    padding: 10,
  },
  paper: {
    padding: 5,
  },
  entry: {
    "&:hover": {
      background: "#D3D3D3",
    },
  },
};

class Data_Modellen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.id,
      data_array: {},
      isLoading: true,
      select_items_list: {},
    };
  }

  fetch_data(id) {
    let post_json = {
      id: id,
      type: "model_data",
      auth: localStorage.getItem("auth"),
    };
    fetch("/api/fetch_data.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-form-urlencoded",
      },
      body: JSON.stringify(post_json),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data.data_array);
        this.setState({
          data_array: data.data_array,
          isLoading: false,
          select_items_list: data,
        });
      });
  }

  componentDidMount() {
    this.fetch_data(this.props.match.params.id);
  }

  Change_State = (someArg) => {
    this.fetch_data(someArg);
    this.setState({ isLoading: true });
  };

  render() {
    if (this.state.isLoading) {
      return <p>Loading ...</p>;
    }

    const { classes } = this.props;
    let src, src_min;
    const {
      ModelID,
      naam,
      FabrikantNummer,
      FabrikantOmschrijving,
      KleurGeheleVoertuig,
      KleurCabine,
      KleurLaadbak,
      KleurLaadbakBinnen,
      KleurOpbouw,
      KleurChassis,
      KleurVelgen,
      KleurBanden,
      Omschrijving,
      Type,
      Schaal_NL,
      Toepassing_NL,
      Materiaal_NL,
      GemaaktVan,
      GemaaktTot,
      Kenmerk1_NL,
      Kenmerk7_NL,
      Kenmerk2_NL,
      Kenmerk8_NL,
      Kenmerk3_NL,
      Kenmerk9_NL,
      Kenmerk4_NL,
      Kenmerk10_NL,
      Kenmerk5_NL,
      Kenmerk11_NL,
      Kenmerk6_NL,
      Kenmerk12_NL,
      Opschriften,
      Ondergrond,
      Exportlanden,
      VerkoopInWinkel,
      AantalStuks,
      InkoopModel,
      Nummer_AantalStuks,
      Nieuwwaarde,
      Toebehoren,
      Kleur,
      Opmerkingen,
    } = this.state.data_array;

    const Images = [
      "Algemeen",
      "LinkerZijkant",
      "RechterZijkant",
      "VoorKant",
      "AchterKant",
      "BovenKant",
      "OnderKant",
      "Set",
    ];

    const Image_Sources = Images.map((item) => {
      src = `/media/Model_images/Model-${ModelID}/${ModelID}-${item}.jpg`;
      // + new Date().getTime();
      src_min = `/media/Model_images/Model-${ModelID}/${ModelID}-${item}_min.jpg`;
      // + new Date().getTime();

      return { src: src, src_min: src_min, type: item };
    });

    const Algemeen = [
      { name: "Type Unimog:", value: Omschrijving },
      { name: "Serie:", value: Type },
      { name: "Verhouding:", value: Schaal_NL },
      { name: "Toepassing:", value: Toepassing_NL },
      { name: "Materiaal:", value: Materiaal_NL },
      { name: "Gemaakt van:", value: GemaaktVan },
      { name: "Gemaakt tot:", value: GemaaktTot },
    ];

    const Kleuren = [
      { name: "Algemeen:", value: KleurGeheleVoertuig },
      { name: "Cabine:", value: KleurCabine },
      { name: "Laadbak:", value: KleurLaadbak },
      { name: "Laadbak binnen:", value: KleurLaadbakBinnen },
      { name: "Opbouw:", value: KleurOpbouw },
      { name: "Chassis:", value: KleurChassis },
      { name: "Velgen:", value: KleurVelgen },
      { name: "Banden:", value: KleurBanden },
    ];

    const Kenmerken = [
      { name: "Wielafstand:", value: Kenmerk1_NL },
      { name: "Bestuurder:", value: Kenmerk7_NL },
      { name: "Uitvoering Cabine:", value: Kenmerk2_NL },
      { name: "Deuren:", value: Kenmerk8_NL },
      { name: "Achteruitkijkspiegel:", value: Kenmerk3_NL },
      { name: "Zwaailicht:", value: Kenmerk9_NL },
      { name: "Voorruit:", value: Kenmerk4_NL },
      { name: "Reservewiel:", value: Kenmerk10_NL },
      { name: "Stuur:", value: Kenmerk5_NL },
      { name: "Trekhaak:", value: Kenmerk11_NL },
      { name: "Stoelen:", value: Kenmerk6_NL },
      { name: "Opschriften:", value: Opschriften },
      { name: "Ondergrond:", value: Ondergrond },
      { name: "Verpakking:", value: Kenmerk12_NL },
    ];

    const Bijzonderheden = [
      { name: "Exportlanden:", value: Exportlanden },
      { name: "VerkoopInWinkel:", value: VerkoopInWinkel },
      { name: "AantalStuks:", value: AantalStuks },
      { name: "InkoopModel:", value: "€ " + InkoopModel },
      { name: "Nummer_AantalStuks:", value: Nummer_AantalStuks },
      { name: "Nieuwwaarde:", value: "€ " + Nieuwwaarde },
    ];

    const Aanbouw = [
      { name: "Toebehoren:", value: Toebehoren },
      { name: "Kleur:", value: Kleur },
    ];

    const ButtonWithRouter = withRouter(Button);
    const { history } = this.props;

    return (
      <React.Fragment>
        <Grid
          container
          justify="center"
          alignItems="flex-start"
          spacing={2}
          style={{
            margin: 10,
            width: "calc(100% - 16px)",
          }}
        >
          <Grid item xs={12} container justify={"center"}>
            <ButtonWithRouter
              onClick={() => history.push("/Form/Modellen/" + ModelID)}
              style={{ background: "white" }}
            >
              Dit model aanpassen
            </ButtonWithRouter>
          </Grid>
          <Grid
            item
            xs={7}
            container
            spacing={1}
            justify={"flex-end"}
            style={{ padding: 5 }}
          >
            <Grid item xs={6}>
              <SimpleModal
                src={Image_Sources[0].src}
                src_min={Image_Sources[0].src_min}
              />
            </Grid>
            <Grid item xs={6} container alignItems="flex-start">
              <Paper style={{ padding: 5, paddingBottom: 20 }}>
                <Grid container spacing={2} justify={"space-around"}>
                  <Grid item xs={7}>
                    <Typography component={"span"} style={{ fontSize: 23 }}>
                      {naam} <span components={"span"}>{FabrikantNummer}</span>
                    </Typography>
                  </Grid>
                  <Grid item xs={4} container justify={"flex-end"}>
                    <Typography>
                      ID: {ModelID}{" "}
                      {ModelID <= 1000
                        ? "wit"
                        : ModelID <= 2000
                        ? "geel"
                        : "oranje"}
                    </Typography>
                  </Grid>
                  <Grid item xs={11}>
                    <Typography style={{ fontSize: 18 }}>
                      {FabrikantOmschrijving}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
              <Grid item xs={12}>
                <Paper style={{ padding: 5, paddingBottom: 20 }}>
                  <Grid container spacing={2} justify={"space-around"}>
                    <Grid item xs={11}>
                      <Typography style={{ fontSize: 18 }}>
                        {"Opmerkingen: " + Opmerkingen}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid
                container
                justify={"space-between"}
                alignItems="stretch"
                spacing={1}
              >
                <Grid item xs={6}>
                  <Paper style={{ padding: 5, height: "calc(100% - 10px)" }}>
                    <Grid container>
                      <Grid item xs={12} container justify={"center"}>
                        <Grid item style={{ fontWeight: "bold" }}>
                          Algemeen
                        </Grid>
                      </Grid>

                      {Algemeen.map((data, index) => {
                        const { name, value } = data;
                        return (
                          <React.Fragment key={index}>
                            <Grid item xs={12}>
                              <Divider />
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              container
                              className={clsx(classes.entry)}
                            >
                              <Grid item xs={6} style={{ fontWeight: "bold" }}>
                                {name}
                              </Grid>
                              <Grid item xs={6}>
                                {value}
                              </Grid>
                            </Grid>
                          </React.Fragment>
                        );
                      })}
                    </Grid>
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <Paper style={{ padding: 5, height: "calc(100% - 10px)" }}>
                    <Grid container>
                      <Grid item xs={12} container justify={"center"}>
                        <Grid item style={{ fontWeight: "bold" }}>
                          Kleuren
                        </Grid>
                      </Grid>

                      {Kleuren.map((data, index) => {
                        const { name, value } = data;
                        return (
                          <React.Fragment key={index}>
                            <Grid item xs={12}>
                              <Divider />
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              container
                              className={clsx(classes.entry)}
                            >
                              <Grid item xs={6} style={{ fontWeight: "bold" }}>
                                {name}
                              </Grid>
                              <Grid item xs={6}>
                                {value}
                              </Grid>
                            </Grid>
                          </React.Fragment>
                        );
                      })}
                    </Grid>
                  </Paper>
                </Grid>
                <Grid item xs={12}>
                  <Paper style={{ padding: 5 }}>
                    <Grid container>
                      <Grid item xs={12} container justify={"center"}>
                        <Grid item style={{ fontWeight: "bold" }}>
                          Kenmerken
                        </Grid>
                      </Grid>

                      {Kenmerken.map((data, index) => {
                        const { name, value } = data;
                        return (
                          <React.Fragment key={index}>
                            {index % 2 === 0 ? (
                              <Grid item xs={12}>
                                <Divider />
                              </Grid>
                            ) : null}
                            <Grid
                              item
                              xs={6}
                              container
                              className={clsx(classes.entry)}
                            >
                              <Grid item xs={6} style={{ fontWeight: "bold" }}>
                                {name}
                              </Grid>
                              <Grid item xs={6}>
                                {value}
                              </Grid>
                            </Grid>
                          </React.Fragment>
                        );
                      })}
                    </Grid>
                  </Paper>
                </Grid>
                <Grid item xs={12}>
                  <Paper style={{ padding: 5 }}>
                    <Grid container>
                      <Grid item xs={12} container justify={"center"}>
                        <Grid item style={{ fontWeight: "bold" }}>
                          Bijzonderheden
                        </Grid>
                      </Grid>

                      {Bijzonderheden.map((data, index) => {
                        const { name, value } = data;
                        return (
                          <React.Fragment key={index}>
                            {index % 2 === 0 ? (
                              <Grid item xs={12}>
                                <Divider />
                              </Grid>
                            ) : null}
                            <Grid
                              item
                              xs={6}
                              container
                              className={clsx(classes.entry)}
                            >
                              <Grid item xs={6} style={{ fontWeight: "bold" }}>
                                {name}
                              </Grid>
                              <Grid item xs={6}>
                                {value}
                              </Grid>
                            </Grid>
                          </React.Fragment>
                        );
                      })}
                    </Grid>
                  </Paper>
                </Grid>
                <Grid item xs={12}>
                  <Paper style={{ padding: 5 }}>
                    <Grid container>
                      <Grid item xs={12} container justify={"center"}>
                        <Grid item style={{ fontWeight: "bold" }}>
                          Aanhanger/Aanbouwapparaat
                        </Grid>
                      </Grid>

                      {Aanbouw.map((data, index) => {
                        const { name, value } = data;
                        return (
                          <React.Fragment key={index}>
                            {index % 2 === 0 ? (
                              <Grid item xs={12}>
                                <Divider />
                              </Grid>
                            ) : null}
                            <Grid
                              item
                              xs={6}
                              container
                              className={clsx(classes.entry)}
                            >
                              <Grid item xs={6} style={{ fontWeight: "bold" }}>
                                {name}
                              </Grid>
                              <Grid item xs={6}>
                                {value}
                              </Grid>
                            </Grid>
                          </React.Fragment>
                        );
                      })}
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={4}>
            <Paper>
              <Grid
                container
                justify="space-evenly"
                alignItems="center"
                style={{ padding: 5 }}
                spacing={1}
              >
                {Image_Sources.map((data, index) => {
                  const names = [
                    null,
                    "Linker Zijkant",
                    "Rechter Zijkant",
                    "Voorkant",
                    "Achterkant",
                    "Bovenkant",
                    "Onderkant",
                    "Set",
                  ];

                  if (index === 0) {
                    return "";
                  }
                  return (
                    <Grid
                      item
                      xs={12}
                      md={6}
                      key={index}
                      container
                      justify="center"
                    >
                      <Grid item>{names[index]}</Grid>
                      <SimpleModal
                        src={Image_Sources[index].src}
                        src_min={Image_Sources[index].src_min}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(Data_Modellen);
